const configuration = {
    rest: 'https://externe-dokumentation.de',
    status: {
        created: 201,
        ok: 200
    },
    reportingYear: 2026
}

export default configuration;